import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { ReactComponent as ForwardRef$1 } from '../../assets/icons/CheckboxCheck.svg.js';
import { ReactComponent as ForwardRef } from '../../assets/icons/CheckboxDash.svg.js';
import style from './Checkbox.module.css.js';

const Checkbox = React__default.forwardRef(({ indeterminate, className, ...attrs }, ref) => {
    return (jsxs("label", { className: classNames(style.checkboxWrapper, className, attrs.disabled && style.disabled), children: [jsx("input", { type: "checkbox", ...attrs, ref: ref }), indeterminate && (jsx("div", { className: classNames(style.checkmark, style.indeterminate), children: jsx(ForwardRef, {}) })), !indeterminate && (jsx("div", { className: classNames(style.checkmark), children: jsx(ForwardRef$1, {}) }))] }));
});
Checkbox.displayName = "Checkbox";

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
